import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'

const AppRouter = props => {
  return (
    <Switch>
      <Route exact path='/result'>
        <Redirect to={`/payments/result${props.history.location.search}`} />
      </Route>
      {/* <Route exact path='/bankcard/main'>
        <Redirect to='/coming-soon' />
      </Route> */}
      <Route
        path='/'
        render={(routeProps) => (
          <PageLayout>
            {require('./Agreements').default(routeProps)}
            {require('./BankCard').default(routeProps)}
            {require('./CashTopUp').default(routeProps)}
            {require('./Checkout').default(routeProps)}
            {require('./Close').default(routeProps)}
            {require('./ComingSoon').default(routeProps)}
            {require('./Error').default(routeProps)}
            {require('./Invoice').default(routeProps)}
            {require('./Maps').default(routeProps)}
            {require('./NearbyStore').default(routeProps)}
            {require('./Payments').default(routeProps)}
            {require('./Transaction').default(routeProps)}
            {require('./Paylink').default(routeProps)}
          </PageLayout>
        )}
      />
    </Switch>
  )
}

export default AppRouter
